export default __webpack_public_path__ + "static/media/success.6c3bdaf0.svg";